import React from "react";
import EmbedPage from "@/pages/EmbedPage";

export default function ShippingRatesPage() {
  return (
    <EmbedPage
      srcPath="/embeds/shipping-rates.html"
      titleKey="shippingRates"
      testIdBase="shipping-rates"
    />
  );
}
